window.$ = window.jQuery = require("jquery");

require("../sass/style.scss");

// require("./vendor/slick.js");

import "./vendor/bootstrap-transition.js";
import "./vendor/bootstrap-collapse.js";
import "./vendor/slick.js";
import "./vendor/jquery-modal-video.js";
import "./vendor/bodyScrollLock";
import "./vendor/jquery.multiselect.js";
import "./vendor/jquery.fancybox.min.js";
import "./vendor/ui.min.js";

import {ajax} from 'jquery';

var currentIndex = 0;// store current pane index displayed
var ePanes = $('.slider-news #slider .panel'),
    time = 10000,
    bar = $('.slider-news .progress_bar');

function showPane(index) {// generic showPane
    ePanes.eq(currentIndex).stop(true, true).fadeOut(0);
    currentIndex = index;
    if (currentIndex < 0) currentIndex = ePanes.length - 1;
    else if (currentIndex >= ePanes.length) currentIndex = 0;
    ePanes.eq(currentIndex).stop(true, true).fadeIn(400);
}

showPane(-1);

function run() {
    bar.width(0);
    showPane(currentIndex + 1);

    if ($(window).width() > 991) {
        bar.animate({'width': "+=90%"}, time, run);
    } else {
        bar.animate({'width': "+=50%"}, time, run);
    }
}

function setBannerHeight() {
    // Dynamically find and assign the height to banners
    if ($('.site-content').length > 0 && $(".ntce-header").length > 0) {
        $('.site-content').attr('style', 'margin-top:' + ($(".ntce-header").height()) + 'px');
        $('body').attr('style', 'padding-top: 0px !important;');
        if($('.hero-builder').length > 0) {
            $('.hero-builder').attr('style', 'padding-top: 0px !important;');
        }
    }    
}

$(window).resize(function () {
    if ($(window).width() > 991) {
        bar.animate({'width': "+=90%"}, time, run);
        bar1.animate({'width': "+=350px"}, time1, run1);
    } else {
        bar.animate({'width': "+=50%"}, time, run);
        bar1.animate({'width': "+=100%"}, time1, run1);
    }
    if ($(window).width() > 500) {
        bar2.animate({'width': "+=350px"}, time2, run2);
    } else {
        bar2.animate({'width': "+=100%"}, time2, run2);
    }

    if ($('.page-template-page_location').length > 0 || $(".single-location").length > 0) {
        // Dynamically find and assign the height to banners
        setBannerHeight();
    }   
});

run();

var ePanesSlider = '';
var currentIndex_slider_builder = -1;
var timeSlider;
var barSlider;

var ePanesSlider_history = '';
var currentIndex_slider_history = -1;
var timeSlider_history;
var barSlider_history;

var ePanes1 = '';
var currentIndex_slider = -1;
var time1;
var bar1;
var ePanes2 = '';
var currentIndex_slider2 = -1;
var time2;
var bar2;
$(document).ready(function () {
    if ($('.page-template-page_location').length > 0) {
        if (navigator.geolocation) {
            $('.use-cur-loc').click(function () {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    searchLocationsNear(latlng);
                });
            })
        }
    }

    if ($('.page-template-page_location').length > 0 || $(".single-location").length > 0) {
        // Dynamically find and assign the height to banners
        setBannerHeight();
    }


    $(".hero .title").addClass("is_on_screen");
    $(".hero .title-underline").addClass("is_on_screen");
    $(".hero .content-sub-title").addClass("is_on_screen");
    $(".hero .content").addClass("is_on_screen");
    $(".hero-executive .title").addClass("is_on_screen");
    $(".hero-executive .title-underline").addClass("is_on_screen");
    $(".hero-builder .title").addClass("is_on_screen");
    $(".hero-builder .content").addClass("is_on_screen");
    $(".hero-builder .title-underline").addClass("is_on_screen");
    parallaxScroll();
    parallaxScrollBusiness();
    //check_num_slider_history();

    $(window).on("scroll", function () {
        var window_top = jQuery(window).scrollTop();

        if (window_top >= 600 && $(window).width() > 991) {
            parallaxScroll();
        }
        if (window_top >= 1500 && $(window).width() > 991) {
            parallaxScrollBusiness();
        }
    });

    ePanes1 = $('.section-multi-slider .panel'), // store panes collection
        time1 = 10000,
        bar1 = $('.section-multi-slider .slider-left .progress_line');
    //$('.section-multi-slider .slider-left .nav-titles ul li').click(function(ev){ bar1.stop(true,true); bar1.width(0);  showPanel($(this).index());   });

    run1();

    ePanes2 = $('.section-multi-slider .panel2'), // store panes collection
        time2 = 10000,
        bar2 = $('.section-multi-slider .slider-right .progress_line2');
    //$('.section-multi-slider .slider-right .nav-titles ul li').click(function(ev){ bar2.stop(true,true); bar2.width(0);  showPanel2($(this).index());   });

    run2();

    ePanesSlider = $('.slider-bios .panelslider'), // store panes collection
        timeSlider = 35000,
        barSlider = $('.slider-bios .progress_line_slider');

    runSlider();

    // ePanesSlider_history = $('.section-slider-history .panel-slider-history'), // store panes collection
    // timeSlider_history   = 6000,
    // barSlider_history = $('.section-slider-history .progress_line_slider_history');

    // runSliderHistory();


});

function run1() {
    bar1.width(0);
    showPanel(currentIndex_slider + 1);
    if ($(window).width() > 991) {
        bar1.animate({'width': "+=350px"}, time1, run1);
    } else {
        bar1.animate({'width': "+=100%"}, time1, run1);
    }
}

function run2() {
    bar2.width(0);
    showPanel2(currentIndex_slider2 + 1);
    if ($(window).width() > 500) {
        bar2.animate({'width': "+=350px"}, time2, run2);
    } else {
        bar2.animate({'width': "+=100%"}, time2, run2);
    }
}

function runSlider() {
    barSlider.width(0);
    showPanelSlider(currentIndex_slider_builder + 1);
    barSlider.animate({'width': "+=0%"}, timeSlider, runSlider);
}

// function runSliderHistory(){
//     barSlider_history.width(0);
//     showPanelSliderHistory(currentIndex_slider_history+1);
//     barSlider_history.animate({'width': "+=0%"}, timeSlider_history, runSliderHistory);
// }

function changeSlider(index) {
    barSlider.stop(true, true);
    barSlider.width(0);
    showPanelSlider(index);
}

function showPanel(index1) {
    ePanes1.eq(currentIndex_slider).fadeOut("slow", function () {
        ePanes1.eq(currentIndex_slider).stop(true, true);
        ePanes1.eq(currentIndex_slider).removeClass('currentslider');
        currentIndex_slider = index1;
        if (currentIndex_slider < 0) currentIndex_slider = ePanes1.length - 1;
        else if (currentIndex_slider >= ePanes1.length) currentIndex_slider = 0;
        ePanes1.eq(currentIndex_slider).stop(true, true).fadeIn("slow");
        ePanes1.eq(currentIndex_slider).addClass('currentslider');
        //console.log("D: "+currentIndex_slider);
        $('.section-multi-slider .slider-left .nav-titles ul li').removeClass('current').eq(currentIndex_slider).addClass('current');
        $('.section-multi-slider .slider-left .slider-text .line a').each(function (index) {
            $(this).removeClass('current');
        });

        $('.section-multi-slider .slider-left .currentslider .slider-text .line a').removeClass('current').eq(currentIndex_slider).addClass('current');
    });
}

function showPanel2(index1) {
    ePanes2.eq(currentIndex_slider2).fadeOut("slow", function () {
        ePanes2.eq(currentIndex_slider2).stop(true, true);
        ePanes2.eq(currentIndex_slider2).removeClass('currentslider');
        currentIndex_slider2 = index1;
        if (currentIndex_slider2 < 0) currentIndex_slider2 = ePanes2.length - 1;
        else if (currentIndex_slider2 >= ePanes2.length) currentIndex_slider2 = 0;
        ePanes2.eq(currentIndex_slider2).stop(true, true).fadeIn("slow");
        ePanes2.eq(currentIndex_slider2).addClass('currentslider');
        $('.section-multi-slider .slider-right .nav-titles ul li').removeClass('current').eq(currentIndex_slider2).addClass('current');

        $('.section-multi-slider .slider-right .slider-text .line a').each(function (index) {
            $(this).removeClass('current');
        });

        $('.section-multi-slider .slider-right .currentslider .slider-text .line a').removeClass('current').eq(currentIndex_slider2).addClass('current');
    });
}

function showPanelSlider(index1) {
    ePanesSlider.eq(currentIndex_slider_builder).fadeOut("slow", function () {
        ePanesSlider.eq(currentIndex_slider_builder).stop(true, true);
        ePanesSlider.eq(currentIndex_slider_builder).removeClass('currentslider');
        currentIndex_slider_builder = index1;
        if (currentIndex_slider_builder < 0) currentIndex_slider_builder = ePanesSlider.length - 1;
        else if (currentIndex_slider_builder >= ePanesSlider.length) currentIndex_slider_builder = 0;
        ePanesSlider.eq(currentIndex_slider_builder).stop(true, true).fadeIn("slow");
        ePanesSlider.eq(currentIndex_slider_builder).addClass('currentslider');

        $('.slider-bios .line_slider a').each(function (index) {
            $(this).removeClass('current');
        });

        $('.slider-bios .line_slider a').removeClass('current').eq(currentIndex_slider_builder).addClass('current');
    });
}

// function showPanelSliderHistory(index1){
//     ePanesSlider_history.eq(currentIndex_slider_history).fadeOut("slow", function() {
//         ePanesSlider_history.eq(currentIndex_slider_history).stop(true, true);
//         ePanesSlider_history.eq(currentIndex_slider_history).removeClass('currentsliderHistory');
//         currentIndex_slider_history = index1;
//         if(currentIndex_slider_history < 0) currentIndex_slider_history = ePanesSlider_history.length-1;
//         else if(currentIndex_slider_history >= ePanesSlider_history.length) currentIndex_slider_history = 0;
//         ePanesSlider_history.eq(currentIndex_slider_history).stop(true, true).fadeIn("slow");
//         ePanesSlider_history.eq(currentIndex_slider_history).addClass('currentsliderHistory');

//         $('.section-slider-history .slider-years .year').each(function( index ) {
//             $(this).removeClass('arrow_box');
//         });

//         $('.section-slider-history .slider-years .year').removeClass('arrow_box').eq(currentIndex_slider_history).addClass('arrow_box');
//     });
// }

// $('.section-slider-history .previous-slider').click(function(){  showPanelSliderHistory(currentIndex_slider_history-1);});
// $('.section-slider-history .next-slider').click(function(){  showPanelSliderHistory(currentIndex_slider_history+1);});

$(window).resize(function () {
    if ($(window).width() > 991) {
        parallaxScroll();
        parallaxScrollBusiness();
    } else {
        $('.section-multi-slider .text-big').css('margin-left', '10%');
        $('.section-multi-slider .text-big-business').css('margin-left', '10%');
    }
    //check_num_slider_history();
});

function parallaxScroll() {

    var scrolled = $(window).scrollTop();
    if (scrolled >= 2500) {
        $('.section-multi-slider .text-big').css('margin-left', (0) + '%');
    } else {

        $('.section-multi-slider .text-big').css('margin-left', (-10 + (scrolled / 25)) + '%');
    }
}

function parallaxScrollBusiness() {

    var scrolled = $(window).scrollTop();
    //console.log("Scroll: "+scrolled);
    if (scrolled >= 3000) {
        $('.section-multi-slider .text-big-business').css('margin-left', (0) + '%');
    } else {

        $('.section-multi-slider .text-big-business').css('margin-left', (-55 + (scrolled / 25)) + '%');
    }
}

// function check_num_slider_history(){
//     var num_slider_history = $(".section-slider-history .slider .slider-years .year").length;
//     if(num_slider_history > 5 && ($(window).width() > 600)){
//         var width_slider = (100/num_slider_history);
//         var size_text = 0;
//         if(num_slider_history > 5 && num_slider_history < 9){ size_text = '2' }
//         if(num_slider_history >= 9 && num_slider_history <= 12){ size_text = '1.5' }
//         if(num_slider_history > 12){ size_text = '1' }
//         $('.section-slider-history .slider-years .year').each(function() {
//             //$(this).attr('style',"width:calc("+width_slider+"% - 10px);font-size:"+size_text+"rem;");
//         });
//     }else{
//         $('.section-slider-history .slider-years .year').each(function() {
//             $(this).removeAttr('style');
//         });
//     }
// }

$('.lem-navbar-toggle').click(function () {
    $('body').toggleClass('menu-open');
    $('.wpmm_mobile_menu_btn').trigger('click');

});

$(function () {
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });
});

$(document).ready(function () {
    my_browser_body_class();

    // showPanel panel click function
    $(document).on('click', 'a.showPanel', function () {
        showPanel($(this).attr('data-slider-panel'));
    });

    // showPanel2 panel click function
    $(document).on('click', 'a.showPanel2', function () {
        showPanel2($(this).attr('data-slider2-panel'));
    });

    // showPanelSlider panel click function
    $(document).on('click', 'a.showPanelSlider', function () {
        showPanelSlider($(this).attr('data-people-panel'));
    });

    // showPanelSliderHistory panel click function
    // $(document).on('click', 'div.year', function() {
    //     showPanelSliderHistory($(this).attr('data-history-panel'));
    // });

    $(document).on('click', '.section-tab-content .tabs a', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            return;
        }
        $('.section-tab-content .tabs a').removeClass('active');
        $(this).addClass('active');
        let tab_id = $(this).attr('data-tabId');
        $('.tab-element-single-wrap').fadeOut(function () {
            $('#tab-' + tab_id).fadeIn();
        });
    });

    //location-tab
    /* Commented on Sep 2, 2204
    localStorage.setItem('filter', 'branch');
    $(document).on('click', '.location-nav a[data-tabid]', function (e) {
        e.preventDefault();
        let select_cat = $(this).data('tabid');
        console.log(select_cat);
        searchLocationsNear(map.center, select_cat);
        localStorage.setItem('filter', select_cat);
    });
    $(document).on('click', '.location-nav a', function (e) {
        $('.location-nav a').removeClass('active');
        $(this).addClass('active');
    });
    */  




    $('#submit-but').on("click", function () {
        searchLocations();
    });

    $(document).on('click', '.location-nav a.open-second-nav', function (e) {
        e.preventDefault();
        $('.secont-nav-atm').toggleClass('open');
    });

    $(document).on('click', '.location-nav .secont-nav-atm .prev i', function (e) {
        $('.secont-nav-atm').toggleClass('open');
    });

    $(document).on('click', '.page-template-page_location .location-wrapper .right .close-button', function (e) {
        $('.page-template-page_location .location-image').toggleClass('closed');
    });




    // Multiple Tab Contents
    $('.section-multiple-tab-content .tabs a:not(:first)').addClass('inactive');
    $('.multiple-tab-element').hide();
    $('.multiple-tab-element:first').show();

    $(document).on('click', '.section-multiple-tab-content .tabs a', function (e) {
        e.preventDefault();
        let tab_id = $(this).attr('data-tabId');
        if ($(this).hasClass('inactive')) { //this is the start of our condition
            $('.section-multiple-tab-content .tabs a').addClass('inactive');
            $(this).removeClass('inactive');
            $('.multiple-tab-element').hide();
            $('#' + tab_id).show();
        }
    });

    // Sign In Block Tab
    $(document).on('click', '.section-signin .signin-option-wrap a', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
            return;
        }
        $('.section-signin .signin-option-wrap a').removeClass('active');
        $(this).addClass('active');
        //$('.section-signin .signin-option-wrap').fadeOut();
        let tab_id = $(this).attr('data-tabId');
        $('.tab-element-single').hide()
        $('#tab-signin-' + tab_id).show();
        $('.tab-element-single').toggleClass('active')

    });

    // $(document).on('click', '.section-signin .tabs a', function (e) {
    //     e.preventDefault();
    //     if ($(this).hasClass('active')) {
    //         return;
    //     }
    //     $('.section-signin .tabs a').removeClass('active');
    //     $(this).addClass('active');
    //     let tab_id = $(this).attr('data-tabId');
    //     $('.tab-element-single').hide()
    //     $('#tab-signin-' + tab_id).show();

    // });

    // header Signin Button Click
    /*$(document).on('click', '.header-signin-button, .signin-responsive-button', function (e) {
        e.preventDefault();
        $('.section-signin').fadeToggle();
    });*/
    $(document).on('click', function (event) {
        if ($(event.target).closest('.header-signin-button, .signin-responsive-button').length) {
            $('.section-signin .signin-optopn-content').hide();
            $('.section-signin .signin-option-wrap').fadeIn(1000);
            $('.section-signin').fadeToggle();
            return;
        } else if ($(event.target).closest('#header-signin-section').length) {
            return;
        } else {
            $('.section-signin').fadeOut();
        }
    });

    $(document).on('click', function (event) {
        if ($(event.target).closest('.section-signin .signin-option-wrap a').length) {
            $('.section-signin .signin-option-wrap').hide();
            $('.section-signin .signin-optopn-content').fadeIn();
            return;
        }
    });

    // $("header #wp-megamenu-menu-1").mouseover(function () {
    //     if ($(".section-signin").is(":visible")) {
    //         $('.section-signin').fadeOut();
    //     }
    // });


    $('.single-post .contact-form-wrapper .post-form-submit-btn').on('click', function () {

        var post_title = $(document).attr('title');
        var post_url = $(location).attr("href");
        var submit_date = new Date().toISOString().split('T')[0];
        $('input[name=post-title]').val(post_title);
        $('input[name=post-url]').val(post_url);
        $('input[name=submit-date]').val(submit_date);
    });


    // Mission Value Slider
    $(".mission-value-slider").slick({
        arrows: false,
        dots: false,
        autoplaySpeed: 3000,
        autoplay: true,
        adaptiveHeight: true,
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerPadding: '500px',
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    centerPadding: '400px',
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    centerPadding: '400px',
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerMode: false,
                }
            }
        ]
    });


    //Two Column Title Content Slider
    $(".two-column-title-content-slider-wrap").slick({
        arrows: false,
        dots: false,
        autoplaySpeed: 5000,
        autoplay: true,
        adaptiveHeight: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    //Slider History
    $('.history-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.history-slider-nav',
        prevArrow: $('.previous-slider'),
        nextArrow: $('.next-slider'),
        adaptiveHeight: true,
    });

    $('.history-slider-nav').slick({
        slidesToShow: 9,
        slidesToScroll: 1,
        asNavFor: '.history-slider-for',
        // centerMode: true,
        focusOnSelect: true,
        arrows: false,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                    variableWidth: false,
                }
            },
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 3,
                    variableWidth: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    variableWidth: false,
                }
            }
        ]
    });


    // // Homepage Hero Section Slider    
    // $('.home-hero-section').slick({
    //     fade: true,
    //     arrows: false,
    //     dots: false,
    //     autoplaySpeed: 5000,
    //     autoplay: true,
    //     infinite: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    // });

    //************************************
    // Location Alert
    //************************************   

    // jQuery(".location-alert-content-wrap .panel-heading").click(function () {        
    //     jQuery(this).next(".location-alert-content-wrap .panel-collapse").slideToggle("slow").parent(".location-alert-content-wrap .panel").toggleClass("active");
    // });    

    jQuery(".location-alert-content-wrap .panel-collapse:not(:first)").css("display", "none");
    jQuery(".location-alert-content-wrap .panel:first-of-type").addClass("active");

    jQuery(".location-alert-content-wrap .panel-heading").on("click", function () {

        if (jQuery(this).parent(".location-alert-content-wrap .panel").hasClass("active")) {
            jQuery(this).next(".location-alert-content-wrap .panel-collapse").slideToggle("slow", function () {
                jQuery(this).parent(".location-alert-content-wrap .panel").toggleClass("active");
            });
        } else {
            jQuery(this).next(".location-alert-content-wrap .panel-collapse").slideToggle("slow").parent(".location-alert-content-wrap .panel").toggleClass("active");
        }
    });


    // Two Column Title Right Content Slider
    $('.two-column-title-slider-content-wrap').slick({
        arrows: false,
        dots: false,
        autoplaySpeed: 6000,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });


    // EXTERNAL LINK popup

    var domain_url = ["plainscapital.com", "digitalacademy.plainscapital.com", document.domain, ""];

    //console.log(domain_url);

    $('a[target="_blank"]:not(.not-external)').on('click', function (e) {

        e.preventDefault();

        var url = $(this).attr('href');

        var domain = url.replace('http://', '').replace('www.', '').replace('https://', '').split(/[/?#]/)[0];


        //Sconsole.log(url);
        if (domain_url.indexOf(domain) > -1) {
            window.open(encodeURI(url), '_blank');
        } else {
            e.preventDefault();
            $('.exitpopup-overlay').fadeIn();
            $('.stay-site').on('click', function () {
                $('.exitpopup-overlay').fadeOut();
            });
            $('.leave-site').on('click', function () {
                //window.location = encodeURI(url);
                window.open(encodeURI(url), '_blank');
                $('.exitpopup-overlay').fadeOut();
                window.location.reload();
            });
        }

    });

    $(document).on('click', '.exitpopup-overlay-IE .close-button', function (event) {
        var cname = 'pcb_ie_enable';
        var cvalue = 'true';
        const d = new Date();
        d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        $('.exitpopup-overlay-IE').fadeOut();
    });


    // Full width Content Slider
    $(window).resize(function () {
        if ($(window).width() > 500) {
            full_width_content_slider_bar.animate({'width': "+=350px"}, full_width_content_slider_time, fullwidthcontentslider);
        } else {
            full_width_content_slider_bar.animate({'width': "+=300px"}, full_width_content_slider_time, fullwidthcontentslider);
        }

    });

    var ePanesfull_width_content_slider = '';
    var full_width_content_slider_time;
    var full_width_content_slider_bar;
    var full_width_content_currentIndex_slider = -1;

    ePanesfull_width_content_slider = $('.full-width-content-slider-wrapper .full-width-content-slider'), // store panes collection
        full_width_content_slider_time = 10000,
        full_width_content_slider_bar = $('.full-width-content-slider-wrapper .full-width-content-slider .full-width-contentprogress-line');
    // $('.full-width-content-slider-wrapper .full-width-content-slider .nav-titles ul li').click(function(ev){
    //     full_width_content_slider_bar.stop(true,true); full_width_content_slider_bar.width(0);
    //     fullwidthcontent($(this).index());
    // });

    fullwidthcontentslider();

    function fullwidthcontentslider() {
        full_width_content_slider_bar.width(0);
        fullwidthcontent(full_width_content_currentIndex_slider + 1);
        if ($(window).width() > 500) {
            full_width_content_slider_bar.animate({'width': "+=350px"}, full_width_content_slider_time, fullwidthcontentslider);
        } else {
            full_width_content_slider_bar.animate({'width': "+=300px"}, full_width_content_slider_time, fullwidthcontentslider);
        }
    }

    function fullwidthcontent(index1) {
        ePanesfull_width_content_slider.eq(full_width_content_currentIndex_slider).fadeOut("slow", function () {
            ePanesfull_width_content_slider.eq(full_width_content_currentIndex_slider).stop(true, true);
            ePanesfull_width_content_slider.eq(full_width_content_currentIndex_slider).removeClass('currentslider');
            full_width_content_currentIndex_slider = index1;
            if (full_width_content_currentIndex_slider < 0) full_width_content_currentIndex_slider = ePanesfull_width_content_slider.length - 1;
            else if (full_width_content_currentIndex_slider >= ePanesfull_width_content_slider.length) full_width_content_currentIndex_slider = 0;
            ePanesfull_width_content_slider.eq(full_width_content_currentIndex_slider).stop(true, true).fadeIn("slow");
            ePanesfull_width_content_slider.eq(full_width_content_currentIndex_slider).addClass('currentslider');
            // $('.full-width-content-slider-wrapper .full-width-content-slider .nav-titles ul li').removeClass('current').eq(full_width_content_currentIndex_slider).addClass('current');
        });
    }

    //  // fullwidthcontentslider panel click function
    $(document).on('click', '.full-width-Panel-anchor', function () {
        fullwidthcontent($(this).attr('data-full-width-panel'));
    });

    // Video Popup
    $('.content-block-video-popup').modalVideo({
        youtube: {
            rel: 0
        }
    });
    $('.two-col-video-popup').modalVideo({
        youtube: {
            rel: 0
        }
    });

    // FAQ Accordion
    $(document).ready(function () {
        if ($('.faq-block-wrapper.layout-1').length > 0 || $('.faq-block-wrapper.layout-2').length > 0) {
            $(document).on('click', '.faq-block-wrapper .faq-question', function () {
                $(this).toggleClass('open').next('.faq-block-wrapper .faq-answer').slideToggle();
            });
        }
    });

    // FAQ Accordion Layout 3
    $(document).ready(function () {
        if ($('.faq-block-wrapper.layout-3').length > 0) {
            // Open the first FAQ item by default
            $('.faq-block-wrapper.layout-3 .faq-item:first .faq-question').addClass('open');
            $('.faq-block-wrapper.layout-3 .faq-item:first .faq-answer').slideDown();

            $(document).on('click', '.faq-block-wrapper.layout-3 .faq-item .faq-question, .faq-block-wrapper.layout-3 .faq-item .icon-plus, .faq-block-wrapper.layout-3 .faq-item .icon-minus', function () {
                // Toggle the 'open' class on the clicked .faq-question
                $(this).toggleClass('open');

                // Slide toggle the corresponding .faq-answer
                $(this).closest('.faq-item').find('.faq-answer').slideToggle();

                // Add 'active' class to the parent .faq-item
                $(this).closest('.faq-item').toggleClass('active');

                // Close any other open faq-items and remove 'active' class from them
                $('.faq-block-wrapper.layout-3 .faq-item').not($(this).closest('.faq-item')).removeClass('active').find('.faq-answer').slideUp();
                $('.faq-block-wrapper.layout-3 .faq-item').not($(this).closest('.faq-item')).find('.faq-question').removeClass('open');
            });
        }
    });

    // $(document).ready(function() {
    //     if ($('.faq-block-wrapper.layout-3 ').length > 0) {
    //         // Open the first FAQ item by default
    //         $('.faq-block-wrapper.layout-3 .faq-item:first .faq-question').addClass('open');
    //         $('.faq-block-wrapper.layout-3 .faq-item:first .faq-answer').slideDown();

    //         $(document).on('click', '.faq-block-wrapper.layout-3 .faq-item .faq-question', function() {
    //             // Toggle the 'open' class on the clicked .faq-question
    //             $(this).toggleClass('open');

    //             // Slide toggle the corresponding .faq-answer
    //             $(this).next('.faq-answer').slideToggle();

    //             // Add 'active' class to the parent .faq-item
    //             $(this).closest('.faq-item').toggleClass('active');

    //             // Close any other open faq-items and remove 'active' class from them
    //             $('.faq-block-wrapper.layout-3 .faq-item').not($(this).closest('.faq-item')).removeClass('active').find('.faq-answer').slideUp();
    //             $('.faq-block-wrapper.layout-3 .faq-item').not($(this).closest('.faq-item')).find('.faq-question').removeClass('open');
    //         });
    //     }
    // });


    // FAQ Accordion Expand All
    $(".faq-expands").click(function () {


        var text = $('.faq-expands').text();

        $('.faq-expands').text(text == "EXPAND ALL" ? "COLLAPSE ALL" : "EXPAND ALL");


        if ($(".faq-expands").hasClass('collapse')) {

            $('.faq-question').removeClass('open').next('.faq-answer').slideUp();

            $(".faq-expands").removeClass('collapse');

        } else {
            $('.faq-question').addClass('open').next('.faq-answer').slideDown();
            $(".faq-expands").addClass("collapse");
        }


    });


    // Crypto Corner & Macro Minute Template FAQ Accordion
    if ($('.crypto-minute-two-col-contnet-img-wrap').length > 0) {
        $(document).on('click', '.crypto-minute-faq-content .crypto-minute-question', function () {
            var $clickedQuestion = $(this);
            var $answer = $clickedQuestion.next('.crypto-minute-answer');
            var slideDownDuration = 800; // Adjust the duration for slideDown (in milliseconds)
            var scrollUpDuration = 1500; // Adjust the duration for scrolling up (in milliseconds)
            var additionalOffset = 100; // Adjust the additional offset as needed

            if ($(this).hasClass('open')) {
                $(this).removeClass('open').next('.crypto-minute-answer').slideUp(1000);
            } else {
                if ($('.crypto-minute-faq-content .crypto-minute-question.open').length > 0) {
                    // Close any opened accordion
                    $('.crypto-minute-faq-content .crypto-minute-question.open')
                        .removeClass('open')
                        .next('.crypto-minute-answer')
                        .slideUp(1000, function () {
                            $('html, body').animate({
                                scrollTop: $clickedQuestion.offset().top - additionalOffset
                            }, scrollUpDuration, function () {
                                $clickedQuestion.addClass('open').next('.crypto-minute-answer').slideDown(1000);
                            });
                        });
                } else {
                    // Open the clicked accordion
                    $(this).addClass('open').next('.crypto-minute-answer').slideDown(1000);
                }

            }
            return;

        });
    }


    // Economic Commentary Template FAQ Accordion

    if ($('.economic-two-col-contnet-img-wrap').length > 0) {
        // Trigger click on the first tab to open it by default
        $('.economic-faq-content .economic-question:first').addClass('open').next('.economic-answer').slideDown();

        // Handle click event for tabs
        $(document).on('click', '.economic-faq-content .economic-question', function () {
            // Toggle open/close state
            if ($(this).hasClass('open')) {
                $(this).removeClass('open').next('.economic-answer').slideUp();
            } else {
                // Open the clicked accordion
                $(this).addClass('open').next('.economic-answer').slideDown();
            }
            return;
        });
    }

    // if($('.economic-two-col-contnet-img-wrap').length > 0) {
    //     $(document).on('click', '.economic-faq-content .economic-question', function () {

    //         if ($(this).hasClass('open')) {
    //             $(this).removeClass('open').next('.economic-answer').slideUp();
    //         } else {
    //             // Close any opened accordion
    //             //$('.economic-faq-content .economic-question.open').removeClass('open').next('.economic-answer').slideUp();

    //             // Open the clicked accordion
    //             $(this).addClass('open').next('.economic-answer').slideDown();
    //         }
    //         return;
    //     });
    // }


    // if ($('.economic-two-col-contnet-img-wrap').length > 0) {
    //     $(document).on('click', '.economic-faq-content .economic-question', function () {
    //         var $clickedQuestion = $(this);
    //         var $answer = $clickedQuestion.next('.economic-answer');
    //         var slideDownDuration = 800; // Adjust the duration for slideDown (in milliseconds)
    //         var scrollUpDuration = 1500; // Adjust the duration for scrolling up (in milliseconds)
    //         var additionalOffset = 100; // Adjust the additional offset as needed

    //         if ($(this).hasClass('open')) {
    //             $(this).removeClass('open').next('.economic-answer').slideUp(1000);
    //         } else {
    //             if($('.economic-faq-content .economic-question.open').length > 0) {
    //                 // Close any opened accordion
    //                 $('.economic-faq-content .economic-question.open')
    //                 .removeClass('open')
    //                 .next('.economic-answer')
    //                 .slideUp(1000, function() { 
    //                     $('html, body').animate({
    //                         scrollTop: $clickedQuestion.offset().top - additionalOffset
    //                     }, scrollUpDuration, function() {
    //                         $clickedQuestion.addClass('open').next('.economic-answer').slideDown(1000);
    //                     });
    //                 });
    //             } else {
    //                 // Open the clicked accordion
    //                 $(this).addClass('open').next('.economic-answer').slideDown(1000);
    //             }

    //         }
    //         return;  

    //     });
    // }


    // if($('.crypto-minute-two-col-contnet-img-wrap').length > 0) {
    //     $(document).on('click', '.crypto-minute-faq-content .crypto-minute-question', function () {

    //         if ($(this).hasClass('open')) {
    //             $(this).removeClass('open').next('.crypto-minute-answer').slideUp();
    //         } else {
    //             // Close any opened accordion
    //             $('.crypto-minute-faq-content .crypto-minute-question.open').removeClass('open').next('.crypto-minute-answer').slideUp();

    //             // Open the clicked accordion
    //             $(this).addClass('open').next('.crypto-minute-answer').slideDown();
    //         }
    //         return;
    //     });
    // }


    function elementInView(elem) {
        return $(window).scrollTop() < $(elem).offset().top + $(elem).height();
    };
    if ($('.two-column-title-content-section').length) {
        var previousScroll = 0;
        var elm_tctcs = $('.two-column-title-content-section');
        $(window).scroll(function () {
            var currentScroll = $(this).scrollTop();
            if (currentScroll > previousScroll) {
                console.log('down');
                if (elementInView($('.two-column-title-content-section'))) {
                    $('.two-column-title-content-section .two-column-title-content-background').addClass("viewed");
                }
            } else {
                console.log('up');
                if (elementInView($('.two-column-title-content-section'))) {
                    $('.two-column-title-content-section .two-column-title-content-background').removeClass("viewed");
                }
            }
            previousScroll = currentScroll;
        });
    }

});

function my_browser_body_class() {
    // jQBrowser v0.2: http://davecardwell.co.uk/javascript/jquery/plugins/jquery-browserdetect/
    eval(function (p, a, c, k, e, d) {
        e = function (c) {
            return (c < a ? "" : e(c / a)) + String.fromCharCode(c % a + 161)
        };
        while (c--) {
            if (k[c]) {
                p = p.replace(new RegExp(e(c), 'g'), k[c])
            }
        }
        return p
    }('Ö ¡(){® Ø={\'¥\':¡(){¢ £.¥},\'©\':{\'±\':¡(){¢ £.©.±},\'¯\':¡(){¢ £.©.¯}},\'¬\':¡(){¢ £.¬},\'¶\':¡(){¢ £.¶},\'º\':¡(){¢ £.º},\'Á\':¡(){¢ £.Á},\'À\':¡(){¢ £.À},\'½\':¡(){¢ £.½},\'¾\':¡(){¢ £.¾},\'¼\':¡(){¢ £.¼},\'·\':¡(){¢ £.·},\'Â\':¡(){¢ £.Â},\'³\':¡(){¢ £.³},\'Ä\':¡(){¢ £.Ä},\'Ã\':¡(){¢ £.Ã},\'Å\':¡(){¢ £.Å},\'¸\':¡(){¢ £.¸}};$.¥=Ø;® £={\'¥\':\'¿\',\'©\':{\'±\':²,\'¯\':\'¿\'},\'¬\':\'¿\',\'¶\':§,\'º\':§,\'Á\':§,\'À\':§,\'½\':§,\'¾\':§,\'¼\':§,\'·\':§,\'Â\':§,\'³\':§,\'Ä\':§,\'Ã\':§,\'Å\':§,\'¸\':§};Î(® i=0,«=».ì,°=».í,¦=[{\'¤\':\'Ý\',\'¥\':¡(){¢/Ù/.¨(°)}},{\'¤\':\'Ú\',\'¥\':¡(){¢ Û.³!=²}},{\'¤\':\'È\',\'¥\':¡(){¢/È/.¨(°)}},{\'¤\':\'Ü\',\'¥\':¡(){¢/Þ/.¨(°)}},{\'ª\':\'¶\',\'¤\':\'ß Ñ\',\'¥\':¡(){¢/à á â/.¨(«)},\'©\':¡(){¢ «.¹(/ã(\\d+(?:\\.\\d+)+)/)}},{\'¤\':\'Ì\',\'¥\':¡(){¢/Ì/.¨(«)}},{\'¤\':\'Í\',\'¥\':¡(){¢/Í/.¨(°)}},{\'¤\':\'Ï\',\'¥\':¡(){¢/Ï/.¨(«)}},{\'¤\':\'Ð\',\'¥\':¡(){¢/Ð/.¨(«)}},{\'ª\':\'·\',\'¤\':\'å Ñ\',\'¥\':¡(){¢/Ò/.¨(«)},\'©\':¡(){¢ «.¹(/Ò (\\d+(?:\\.\\d+)+(?:b\\d*)?)/)}},{\'¤\':\'Ó\',\'¥\':¡(){¢/æ|Ó/.¨(«)},\'©\':¡(){¢ «.¹(/è:(\\d+(?:\\.\\d+)+)/)}}];i<¦.Ë;i++){µ(¦[i].¥()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¥=¦[i].¤;® ­;µ(¦[i].©!=²&&(­=¦[i].©())){£.©.¯=­[1];£.©.±=Ê(­[1])}ê{® Ç=Ö ë(¦[i].¤+\'(?:\\\\s|\\\\/)(\\\\d+(?:\\\\.\\\\d+)+(?:(?:a|b)\\\\d*)?)\');­=«.¹(Ç);µ(­!=²){£.©.¯=­[1];£.©.±=Ê(­[1])}}×}};Î(® i=0,´=».ä,¦=[{\'ª\':\'¸\',\'¤\':\'ç\',\'¬\':¡(){¢/é/.¨(´)}},{\'¤\':\'Ô\',\'¬\':¡(){¢/Ô/.¨(´)}},{\'¤\':\'Æ\',\'¬\':¡(){¢/Æ/.¨(´)}}];i<¦.Ë;i++){µ(¦[i].¬()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¬=¦[i].¤;×}}}();', 77, 77, 'function|return|Private|name|browser|data|false|test|version|identifier|ua|OS|result|var|string|ve|number|undefined|opera|pl|if|aol|msie|win|match|camino|navigator|mozilla|icab|konqueror|Unknown|flock|firefox|netscape|linux|safari|mac|Linux|re|iCab|true|parseFloat|length|Flock|Camino|for|Firefox|Netscape|Explorer|MSIE|Mozilla|Mac|toLowerCase|new|break|Public|Apple|Opera|window|Konqueror|Safari|KDE|AOL|America|Online|Browser|rev|platform|Internet|Gecko|Windows|rv|Win|else|RegExp|userAgent|vendor'.split('|')))

    /* ----------------------------------------------------------------- */

    var aol = $.browser.aol();       // AOL Explorer
    var camino = $.browser.camino();    // Camino
    var firefox = $.browser.firefox();   // Firefox
    var flock = $.browser.flock();     // Flock
    var icab = $.browser.icab();      // iCab
    var konqueror = $.browser.konqueror(); // Konqueror
    var mozilla = $.browser.mozilla();   // Mozilla
    var msie = $.browser.msie();      // Internet Explorer Win / Mac
    var netscape = $.browser.netscape();  // Netscape
    var opera = $.browser.opera();     // Opera
    var safari = $.browser.safari();    // Safari


    var userbrowser = $.browser.browser(); //detected user browser


    //operating systems

    var linux = $.browser.linux(); // Linux
    var mac = $.browser.mac();   // Mac OS
    var win = $.browser.win();   // Microsoft Windows

    //version

    var userversion = $.browser.version.number();

    /* ----------------------------------------------------------------- */

    if (mac == true) {

        $("body").addClass("mac");


    } else if (linux == true) {

        $("body").addClass("linux");

    } else if (win == true) {

        $("body").addClass("windows");

    }


    /* ----------------------------------------------------------------- */

    //iphone|ipod|ipad

    var deviceAgent = navigator.userAgent.toLowerCase();
    // var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);

    if (deviceAgent.match(/iphone/)) {
        $("body").addClass("iphone");
    } else if (deviceAgent.match(/ipod/)) {
        $("body").addClass("ipod");
    } else if (deviceAgent.match(/ipad/)) {
        $("body").addClass("ipad");
    }


    /* ----------------------------------------------------- */

    //IE|Edge|Chrome

    var sBrowser, sUsrAg = navigator.userAgent;

    if (sUsrAg.indexOf("Trident") > -1) {
        $("body").addClass("ie");
    } else if (sUsrAg.indexOf("Edge") > -1) {
        $("body").addClass("edge");
    } else if (sUsrAg.indexOf("Chrome") > -1) {
        $("body").addClass("chrome");
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
        $("body").addClass("opera");
    }


    /* ----------------------------------------------------------------- */

    //Browser

    if (userbrowser == "Safari") {

        $("body").addClass("safari");

    } else if (userbrowser == "Firefox") {

        $("body").addClass("firefox");

    } else if (userbrowser == "Camino") {

        $("body").addClass("camino");

    } else if (userbrowser == "AOL Explorer") {

        $("body").addClass("aol");

    } else if (userbrowser == "Flock") {

        $("body").addClass("flock");

    } else if (userbrowser == "iCab") {

        $("body").addClass("icab");

    } else if (userbrowser == "Konqueror") {

        $("body").addClass("konqueror");

    } else if (userbrowser == "Netscape") {

        $("body").addClass("netscape");

    } else {
    }

    $("body").addClass("" + userversion + "");

    $("body").addClass("version-" + userversion + "");

}


// Equal height
(function ($) {
    $.fn.equalizeTheHeights = function (minHeight, maxHeight, breakPoint) {
        var selector, minHeight, maxHeight, breakPoint;
        var heights = [];
        var width = $(window).width();
        selector = this;
        minHeight = minHeight || null;
        maxHeight = maxHeight || null;
        breakPoint = breakPoint || 0;
        if (width < breakPoint) {
            $(selector).height('auto');
            return;
        }
        var height
        selector.each(function () {
            height = $(this).height();
            heights.push(height);
        });
        var maxHeight = Math.max.apply(null, heights);
        // console.log(heights,maxHeight);
        selector.each(function () {
            $(this).height(maxHeight);
        });


    };

    $.fn.equalizeTheHeightsByRow = function (minHeight, maxHeight, breakPoint, elm) {
        var selector, minHeight, maxHeight, breakPoint;
        var heights = [];
        var width = $(window).width();
        selector = this;
        minHeight = minHeight || null;
        maxHeight = maxHeight || null;
        breakPoint = breakPoint || 0;
        if (width < breakPoint) {
            $(selector).height('auto');
            return;
        }
        selector.each(function () {
            heights = [];
            $(this).find(elm).each(function () {
                var height = $(this).height();
                heights.push(height);
            });
            var maxHeight = Math.max.apply(null, heights);
            $(this).find(elm).height(maxHeight);
            // console.log(heights,maxHeight);

        });
    };


    $(window).on('load', function () {


        // Initialisation scripts #1
        //$('.section-personal-banking-services .wrapper .services-grid .services-row').equalizeTheHeightsByRow(null, null, 768, '.service h3');
        //$(window).resize(function () {
        //   $('.section-personal-banding-services .wrapper .services-grid .services-row').equalizeTheHeightsByRow(null, null, 768, '.service h3');
        //});

        // Initialisation scripts #2
        //$('.content-widgets-block-wrapper .content-widgets-block .content-widgets-contents .content p').equalizeTheHeights(null, null, 768);
        //$(window).resize(function () {
        //  $('.content-widgets-block-wrapper .content-widgets-block .content-widgets-contents .content p').equalizeTheHeights(null, null, 768);
        //});

        // Initialisation scripts #3
        //jQuery('.section-personal-banking-services .wrapper .services-grid .services-row .service .content').equalizeTheHeights(null, null, 768);
        //jQuery(window).resize(function () {
        //  jQuery('.section-personal-banding-services .wrapper .services-grid .services-row .service .content').equalizeTheHeights(null, null, 768);
        //});


        // Initialisation scripts #4
        // $('.section-personal-banking-services .wrapper .services-grid .services-row').equalizeTheHeightsByRow(null, null, 768, '.service .icon');
        // $(window).resize(function () {
        //     $('.section-personal-banding-services .wrapper .services-grid .services-row').equalizeTheHeightsByRow(null, null, 768, '.service .icon');
        // });

        $(".content-widgets-contents .content p").equalizeTheHeights(null, null, 768);
        $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper").equalizeTheHeights(null, null, 768);
        // $(".section-blog .blog-title").equalizeTheHeights(null, null, 768);
        // $(".section-blog .blog-content").equalizeTheHeights(null, null, 768);
        // $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper h3.blog-article-title").equalizeTheHeights(null, null, 768);
        // $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper .blog-article-content").equalizeTheHeights(null, null, 768);
        //$('.blog-listing-block .blog-listing-wrap .blog-article-block').equalizeTheHeightsByRow(null, null, 768, '.blog-article-content-wrapper h3');

        // Homepage Hero Section Slider

        $('.home-hero-section').slick({
            fade: true,
            arrows: false,
            dots: false,
            autoplaySpeed: 5000,
            autoplay: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });

    });


}(jQuery));


// Image and Content Slider
var ePanesimage_content_slider = '';
var image_content_slider_time;
var image_content_slider_bar;
var image_content_currentIndex_slider = -1;

$(document).ready(function () {


    ePanesimage_content_slider = $('.section-image-content-slider .content'), // store panes collection
        image_content_slider_time = 10000,
        image_content_slider_bar = $('.section-image-content-slider .slider-content .progress_line');

    image_content_slider();


});

function image_content_slider() {
    image_content_slider_bar.width(0);
    image_content(image_content_currentIndex_slider + 1);
    if ($(window).width() > 991) {
        image_content_slider_bar.animate({'width': "+=430px"}, image_content_slider_time, image_content_slider);
    } else {
        image_content_slider_bar.animate({'width': "+=80%"}, image_content_slider_time, image_content_slider);
    }


}


function image_content(index1) {
    ePanesimage_content_slider.eq(image_content_currentIndex_slider).fadeOut("slow", function () {
        ePanesimage_content_slider.eq(image_content_currentIndex_slider).stop(true, true);
        ePanesimage_content_slider.eq(image_content_currentIndex_slider).removeClass('currentslider');
        image_content_currentIndex_slider = index1;
        if (image_content_currentIndex_slider < 0) image_content_currentIndex_slider = ePanesimage_content_slider.length - 1;
        else if (image_content_currentIndex_slider >= ePanesimage_content_slider.length) image_content_currentIndex_slider = 0;
        ePanesimage_content_slider.eq(image_content_currentIndex_slider).stop(true, true).fadeIn("slow");
        ePanesimage_content_slider.eq(image_content_currentIndex_slider).addClass('currentslider');
    });
}

// Location Page Scrollbar
(function ($) {


    $('.location-search-callout-contents button').click(function () {
        let mes_value = $('.location-search-callout-contents input').val();
        localStorage.setItem('local', mes_value);
        window.location.href = "/locations";

    })

})(jQuery);


var page = 2;
var perPage = $('#WPPerPage').val();

// Blog Listing Ajax Pagination
(function ($) {
    $('#loadmoreanchor').click(function () {
        $('#loadmoreanchor .text').html('LOADING POSTS, PLEASE WAIT..');
        if (($('#categoryId').val())) {
            var load_url = '?paged=' + page + '&category=' + $('#categoryId').val();
        } else {
            var load_url = '?paged=' + page;
        }

        console.log("adA");


        $('#postsLazyload').append($('<div class="blog-listing-wrap" id="post_section' + page + '">').load(load_url + ' .blog-listing-wrap > *', function () {
            page++;
            $('#loadmoreanchor .text').html('LOAD MORE ARTICLES');
            if ($('#WPTotalNumPages').val() < page) {
                $('.loadmoreanchor-wrap').css('display', 'none');
            }
            $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper").equalizeTheHeights(null, null, 768);
            // $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper h3.blog-article-title").equalizeTheHeights(null, null, 768);
            // $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper .blog-article-content").equalizeTheHeights(null, null, 768);
        }));


    });
})(jQuery);

// Blog Listing Category Filter Ajax
$(function () {
    $('.filter-button').click(function () {
        page = '';
        var currentCategory = $(this).attr('id');
        var load_url = '?paged=' + page + '&category=' + currentCategory;
        $('.loadmoreanchor-wrap').css('display', 'none');
        $('.post-filter-section a').removeClass('active');
        $(this).addClass('active');
        $('#categoryId').val(currentCategory);
        $(".blog-listing-wrap").remove();
        $('#postsLazyload').append('<div class="category-posts-loading">Loading... Please wait.</div>');
        $('#postsLazyload').append($('<div class="blog-listing-wrap" id="post_section' + page + '">').load(load_url + ' .blog-listing-wrap > *', function () {
            $('.category-posts-loading').remove();

            $('#WPTotalNumPages').val($('#post_section' + page + ' .WPTotalNumPages2').val());


            if ($('#post_section' + page + ' .WPTotalNumPages2').val() == 1) {
                return;
            }
            $('.loadmoreanchor-wrap').css('display', 'block');
            // if($('#post_section' + page + ' .WPTotalNumPages2').val() < page) {
            //     $('.loadmoreanchor-wrap').css('display', 'none');
            // } else {
            //     $('.loadmoreanchor-wrap').css('display', 'block');
            // }
            page = 1;
            page++;
            $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper").equalizeTheHeights(null, null, 768);
            // $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper h3.blog-article-title").equalizeTheHeights(null, null, 768);
            // $(".blog-listing-block .blog-listing-wrap .blog-article-block .blog-article-content-wrapper .blog-article-content").equalizeTheHeights(null, null, 768);
        }));
    });
});


$((function () {

    var tabName = window.location.hash;

    // Shorten #tab2 to just last digit "2".
    var tabNumber = tabName.substr(5, 1);
    if (tabName != '' && (tabName == '#tab-1' || tabName == '#tab-2')) {
        if ($(tabName).length) {
            $('.section-tab-content .tabs a').removeClass('active');
            $('.section-tab-content .tabs a[data-tabid=' + tabNumber + ']').addClass('active');
            $('.tab-element-single-wrap').fadeOut(function () {
                $(tabName).fadeIn();
            });
        }
    }

}));

$(document).ready(function () {
    //open search
    $('.search-open').click(function (e) {
        e.preventDefault();
        $('.search-wrap').toggleClass('active');
        $.scrollLock(true);
        $('.search-wrap input[name=s]').focus();

    });
    $('.search-wrap .close').click(function (e) {
        e.preventDefault();
        $('.search-wrap').toggleClass('active');
        $.scrollLock(false);
    });
});

// Current Rates Accordion
$(document).on('click', '.current-rates-title', function () {
    $(this).toggleClass('open').next('.current-rate-table-content').slideToggle();
});

$(document).ready(function () {
    $('.tooltip').tooltipster({
        theme: 'tooltipster-shadow'
    });
});

//customscroll
$(window).on("load", function () {
    $(".locations-list").mCustomScrollbar({
        live:true,
        advanced: {updateOnContentResize: true}
    });
    $(".two-col-accordion-content .two-col-accordion .panel-body").mCustomScrollbar({
        advanced: {updateOnContentResize: true}
    });
    $(".two-col-accordion-content .two-col-accordion-wrap .two-col-right-content-wrap").mCustomScrollbar({
        advanced: {updateOnContentResize: true}
    });

    //Digital Acadamy
    if ($('.digital-academy-tab-content-wrap').length > 0) {
        $(".digital-academy-tab-content-wrap .digital-academy-right-content-wrap").mCustomScrollbar({
            advanced: {updateOnContentResize: true}
        });
    }

    //calculating two-col-accordion panel divs total height & adding that height to two-col-accordion div
    var totalHeight = 0;
    $(".two-col-accordion-content .two-col-right-content-wrap .two-col-accordion .panel").each(function () {
        totalHeight += $(this).height();
    });
    $(".two-col-accordion-content .two-col-right-content-wrap .two-col-accordion").css("height", +totalHeight);


});

//Newsroom In The New tab button
jQuery(document).ready(function ($) {
    $('.news-button a').each(function () {
        $(this).attr('target', '_blank');
    });
});


// Two Column Accordion Content
jQuery(document).ready(function () {


    var $dropDowns = $('.two-col-accordion-content .two-col-accordion .panel-group'),
        $topTab = $dropDowns.find('.panel')

    $topTab.filter(':first-of-type').addClass('active');
    $topTab.filter(':first-of-type').find('.panel-body').slideDown();


    $('.two-col-accordion-content .two-col-accordion .panel-heading').click(function () {
        if ($(this).parent().parent(".panel").hasClass("active")) {
            $(this).parent().parent(".panel").removeClass("active");
            $(this).siblings(".panel-body").slideUp(300);
        } else {
            $(".panel").removeClass("active");
            $(".panel .panel-body").slideUp(300);
            $(this).parent().parent(".panel").addClass("active");
            $(this).siblings(".panel-body").slideDown(300);
        }
    })
});


//Financial Journey Contact Callout Multiselect 
jQuery(document).ready(function () {
    $('.contact-callout-block-wrapper .contact-form-wrapper #cntfservices').multiselect({
        texts: {
            placeholder: 'Services Interested In?',
        }
    });
});

jQuery(document).ready(function () {
    $('.contact-callout-block-wrapper .contact-form-wrapper #services').multiselect({
        columns: 1,
        selectAll: true,
        texts: {
            placeholder: 'Services Interested In?',
        },
    });
});


//Digital Academy Tab Content
jQuery(document).ready(function () {

    jQuery(document).keyup(function (e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`

            if ($('.digital-lemonade-wrap #player').is(':empty')) {
                // do nothing
            } else {
                $('#two-col-acc-lm-val').val("");
                destroyPlayer();
                $('html,body').animate({
                        scrollTop: $(".digital-academy-tab").offset().top - 130
                    },
                    'slow');
            }
        }
    });

    if ($('.digital-academy-tab-content-wrap').length > 0) {
        $('.digital-academy-tab-content-wrap .digital-academy-tab a:first-of-type').addClass('active');
        $('.digital-academy-content .digital-academy-tab-content:first-of-type').addClass('active');
        $('.digital-academy-tab-content-wrap .digital-academy-tab a').click(function () {
            var tab_id = $(this).attr('data-tabId');
            $('.digital-academy-tab-content-wrap .digital-academy-tab a').removeClass('active');
            $('.digital-academy-content .digital-academy-tab-content').removeClass('active');
            $(this).addClass('active');
            $("#" + tab_id).addClass('active');
            destroyPlayer();
            $('#two-col-acc-lm-val').val("");
        })
    }

    function destroyPlayer() {
        const playerNode = document.getElementById("player");
        while (playerNode.firstChild) {
            playerNode.removeChild(playerNode.lastChild);
        }
    }

    function LemonadePlayerInit(targetId) {
        destroyPlayer();
        Lemonade.DemoPlayer.play({
            demo: targetId,
            container: $("#player"),
            disableAutoScroll: false,
            finishButtonText: "Close",
            horizontalPadding: 25,
            onFinish: (playerInstance) => {
                setTimeout(function () {
                    $('html,body').animate({
                            scrollTop: $(".digital-academy-tab-content-wrap").offset().top - 110
                        },
                        'slow');
                }, 500);
                destroyPlayer();
                playerInstance.restart();
            },
            onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                // every time the scene changes, this event is called
            },
        });
    }

    //Digital Academy Tab Content Lemonade
    if ($('.digital-academy-tab-content-wrap').length > 0) {
        $('.digital-academy-tab-content-wrap .two-col-right-title .two-col-acc-lm-btn, .digital-academy-tab-content-wrap .two-col-right-title .two-col-acc-text').click(function (event) {
            event.preventDefault();
            var lemonade_id = $(this).attr('data-attr-id');
            var inputval = $('#two-col-acc-lm-val').val();
            var targetId = $(this).attr('data-id');
            $('#two-col-acc-lm-val').val(lemonade_id);
            let querySelector = document.querySelector(".digital-academy-tab-content-wrap .two-col-right-title .two-col-acc-lm-btn, .digital-academy-tab-content-wrap .two-col-right-title .two-col-acc-text");
            querySelector.removeEventListener("click", function () {
            });
            if (lemonade_id === inputval) {
                $('#two-col-acc-lm-val').val("");
                destroyPlayer();
            } else if (lemonade_id != inputval) {
                $('.digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
                $('html,body').animate({
                        scrollTop: $(".digital-lemonade-wrap").offset().top - 110
                    },
                    200);
                $('#' + lemonade_id).slideDown();
                setTimeout(function () {
                    LemonadePlayerInit(targetId);
                }, 100);
            }
            querySelector.addEventListener("click", function () {
            });
            return;
        })
    }
});

//Digital Academy Tab Content Single
jQuery(document).ready(function () {
    if ($('.digital-academy-tab-content-single-wrap').length > 0) {
        $('.digital-academy-tab-content-single-wrap .digital-academy-tab a:first-of-type').addClass('active');
        $('.digital-academy-tab-content-single-wrap .digital-academy-content .digital-academy-tab-content:first-of-type').addClass('active');

        $('.digital-academy-tab-content-single-wrap .digital-academy-tab a').click(function () {
            var tab_id = $(this).attr('data-tabId');

            $('.digital-academy-tab-content-single-wrap .digital-academy-tab a').removeClass('active');
            $('.digital-academy-tab-content-single-wrap .digital-academy-content .digital-academy-tab-content').removeClass('active');

            $(this).addClass('active');
            $(".digital-academy-tab-content-single-wrap #" + tab_id).addClass('active');
            destroyPlayerSinge();
        })

        $('.digital-academy-tab-content-single-wrap .digital-academy-content .tab-contnt-btn.tab-youtube-btn').click(function () {
            $(this).toggleClass('active');
            $('.digital-academy-tab-content-single-wrap .digital-academy-tab-content.active >.digital-academy-content-wrap .tab-contnt-video-wrap').slideToggle('slow', function () {
                // Animation complete.
            });
        });


        function destroyPlayerSinge() {
            const playerNode = document.getElementById("player");
            while (playerNode.firstChild) {
                playerNode.removeChild(playerNode.lastChild);
            }
        }

        function LemonadePlayerInitSingle(targetId) {

            destroyPlayerSinge();
            Lemonade.DemoPlayer.play({
                demo: targetId,
                container: $("#player"),
                disableAutoScroll: false,
                finishButtonText: "Close",
                horizontalPadding: 25,
                onFinish: (playerInstance) => {
                    setTimeout(function () {
                        $('html,body').animate({
                                // scrollTop: $(".digital-academy-content").offset().top},
                                scrollTop: $(".digital-academy-tab-content-single-wrap .digital-academy-content-wrap").offset().top - 110
                            },
                            'slow');
                    }, 500);
                    destroyPlayerSinge();
                    playerInstance.restart();
                },
                onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                    // every time the scene changes, this event is called
                },
            });

        }

        $('.digital-academy-tab-content-single-wrap .digital-academy-content .tab-contnt-btn.tab-lemonade-btn').click(function () {
            $(this).toggleClass('active');
            var targetId = $(this).attr('data-id');
            var lemonade_id = $(this).attr('data-attr-id');

            $('.digital-academy-tab-content-single-wrap .digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
            $('html,body').animate({
                    scrollTop: $(".digital-academy-tab-content-single-wrap .digital-lemonade-wrap").offset().top - 110
                },
                200);
            //$('#'+lemonade_id).slideDown();                
            setTimeout(function () {
                LemonadePlayerInitSingle(targetId);
            }, 100);


            // $('.digital-academy-tab-content-single-wrap .digital-academy-tab-content.active > .digital-academy-content-wrap .digital-lemonade-wrap .digital-lemonade-code').children('div').attr('id','player');
            // //setTimeout(function(){
            //     $('.digital-academy-tab-content-single-wrap .digital-academy-tab-content.active >.digital-academy-content-wrap .digital-lemonade-wrap').slideDown();
            // //}, 500); 

            // setTimeout(function(){
            //     LemonadePlayerInitSingle(targetId);
            // }, 500);

        });

        $('.digital-academy-tab-content-single-wrap .digital-academy-content .tab-lemonade-btn.active').click(function () {
            //$('.digital-academy-tab-content-single-wrap .digital-academy-tab-content.active > .digital-academy-content-wrap .digital-lemonade-wrap .digital-lemonade-code').children('div').removeAttr('id');
            destroyPlayerSinge();
        });
    }
});


//Digital Academy Tab Content Multi
jQuery(document).ready(function () {

    if ($('.digital-academy-tab-content-multi-wrap').length > 0) {
        $('.digital-academy-tab-content-multi-wrap .digital-academy-tab a:first-of-type').addClass('active');
        $('.digital-academy-tab-content-multi-wrap .digital-academy-content .digital-academy-tab-content:first-of-type').addClass('active');

        $('.digital-academy-tab-content-multi-wrap .digital-academy-tab a').click(function () {
            var multi_tab_id = $(this).attr('data-tab-Id');

            $('.digital-academy-tab-content-multi-wrap .digital-academy-tab a').removeClass('active');
            $('.digital-academy-tab-content-multi-wrap .digital-academy-content .digital-academy-tab-content').removeClass('active');

            $(this).addClass('active');
            $(".digital-academy-tab-content-multi-wrap #" + multi_tab_id).addClass('active');
            destroyPlayerMulti();
            $('#digital-acc-lm-val').val("");

        })

    }

    function destroyPlayerMulti() {
        const playerNode = document.getElementById("player");
        while (playerNode.firstChild) {
            playerNode.removeChild(playerNode.lastChild);
        }
    }

    function LemonadePlayerInitMulti(targetId) {

        destroyPlayerMulti();
        Lemonade.DemoPlayer.play({
            demo: targetId,
            container: $("#player"),
            disableAutoScroll: false,
            finishButtonText: "Close",
            horizontalPadding: 25,
            onFinish: (playerInstance) => {
                setTimeout(function () {
                    $('html,body').animate({
                            // scrollTop: $(".digital-academy-content").offset().top},
                            scrollTop: $(".digital-academy-tab-content-multi-wrap .academy-tab-wrap").offset().top - 110
                        },
                        'slow');
                }, 500);
                destroyPlayerMulti();
                playerInstance.restart();
            },
            onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                // every time the scene changes, this event is called
            },
        });
    }


    //Digital Academy Tab Content Multi Lemonade
    if ($('.digital-academy-tab-content-multi-wrap').length > 0) {
        $('.digital-academy-tab-content-multi-wrap .digital-academy-content-wrap .tab-lemonade-btn').click(function (event) {
            event.preventDefault();
            var lemonade_id = $(this).attr('data-attr-id');
            var inputval = $('#digital-acc-lm-val').val();
            var targetId = $(this).attr('data-id');
            $('#digital-acc-lm-val').val(lemonade_id);
            let querySelector = document.querySelector(".digital-academy-tab-content-multi-wrap .digital-academy-content-wrap .tab-lemonade-btn");
            querySelector.removeEventListener("click", function () {
            });

            if (lemonade_id === inputval) {
                $('.digital-academy-tab-content-multi-wrap .tab-contnt-video').hide();
                $('#digital-acc-lm-val').val("");
                destroyPlayerMulti();
                // $('.digital-academy-tab-content-multi-wrap .digital-lemonade-wrap-inner > div').hide();
                // $('#digital-acc-lm-val').val(""); 
                // $('.digital-academy-tab-content-multi-wrap .digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
                // $('#'+lemonade_id).children('div').attr('id','player');   


            } else if (lemonade_id != inputval) {
                $('.digital-academy-tab-content-multi-wrap .tab-contnt-video').hide();
                $('.digital-academy-tab-content-multi-wrap .digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
                $('html,body').animate({
                        scrollTop: $(".digital-academy-tab-content-multi-wrap .digital-lemonade-wrap").offset().top - 110
                    },
                    200);
                $('#' + lemonade_id).slideDown();
                setTimeout(function () {
                    LemonadePlayerInitMulti(targetId);
                }, 100);


            }

            querySelector.addEventListener("click", function () {
            });
            return;

        })
    }

    //Digital Academy Tab Content Multi YouTube
    if ($('.digital-academy-tab-content-multi-wrap').length > 0) {
        $('.digital-academy-tab-content-multi-wrap .digital-academy-content-wrap .tab-youtube-btn').click(function (event) {
            event.preventDefault();
            var lemonade_id = $(this).attr('data-attr-id');
            var inputval = $('#digital-acc-lm-val').val();

            var targetId = $(this).attr('data-id');

            $('#digital-acc-lm-val').val(lemonade_id);


            let querySelector = document.querySelector(".digital-academy-tab-content-multi-wrap .digital-academy-content-wrap .tab-youtube-btn");

            querySelector.removeEventListener("click", function () {
            });


            if (lemonade_id === inputval) {
                destroyPlayerMulti();
                $('.digital-academy-tab-content-multi-wrap .tab-contnt-video').hide();
                $('#digital-acc-lm-val').val("");

            } else if (lemonade_id != inputval) {
                destroyPlayerMulti();
                $('.digital-academy-tab-content-multi-wrap .tab-contnt-video').hide();
                $('html, body').stop().animate({
                        scrollTop: $(".digital-academy-tab-content-multi-wrap .digital-academy-tab-content.active .digital-academy-content-wrap .tab-cotnt-video-wrap").offset().top - 110
                    },
                    'slow');
                $('#' + lemonade_id).slideDown();

            } else {
                destroyPlayerMulti();
                $('html, body').stop().animate({
                        scrollTop: $(".digital-academy-tab-content-multi-wrap .digital-academy-tab-content.active .digital-academy-content-wrap .tab-cotnt-video-wrap").offset().top - 110
                    },
                    'slow');
                $('.digital-academy-tab-content-multi-wrap .tab-contnt-video').show();
                setTimeout(function () {
                    $('#' + lemonade_id).slideDown();
                }, 500);

            }

            querySelector.addEventListener("click", function () {
            });
            return;

        })
    }
});


//Digital Academy Two Column
jQuery(document).ready(function () {

    jQuery(document).keyup(function (e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`

            if ($('.digital-lemonade-wrap #player').is(':empty')) {
                // do nothing
            } else {
                $('#two-col-acc-lm-val').val("");
                destroyPlayerTwoCol();
                $('html,body').animate({
                        scrollTop: $(".digital-academy-two-col").offset().top - 130
                    },
                    'slow');
            }
        }
    });


    function destroyPlayerTwoCol() {
        const playerNode = document.getElementById("player");
        while (playerNode.firstChild) {
            playerNode.removeChild(playerNode.lastChild);
        }
    }

    function LemonadePlayerTwoCol(targetId, da_section_id) {
        destroyPlayerTwoCol();
        Lemonade.DemoPlayer.play({
            da_btn_id: da_section_id,
            demo: targetId,
            container: $("#player"),
            disableAutoScroll: false,
            finishButtonText: "Close",
            horizontalPadding: 25,
            onFinish: (playerInstance) => {
                setTimeout(function () {
                    $('html,body').animate({
                            scrollTop: $(".digital-academy-two-col-wrap #" + da_section_id).offset().top - 110
                        },
                        'slow');
                }, 500);
                destroyPlayerTwoCol();
                playerInstance.restart();
            },
            onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                // every time the scene changes, this event is called
            },
        });
    }

    //Digital Academy Two Column Lemonade
    if ($('.digital-academy-two-col-wrap').length > 0) {


        // console.log(da_cls);  
        $('.digital-academy-two-col-wrap .da-two-col-content .da-two-col-btn-wrap .da-two-col-btn-link').click(function (event) {
            event.preventDefault();
            var da_section_id = $(this).attr('data-index-id');
            var targetId = $(this).attr('data-id');
            var inputval = $('#da-two-col-lm-val').val();
            $('#da-two-col-lm-val').val(da_section_id);


            let querySelector = document.querySelector(".digital-academy-two-col-wrap .da-two-col-content .da-two-col-btn-wrap .da-two-col-btn-link");
            querySelector.removeEventListener("click", function () {
            });

            if (da_section_id === inputval) {
                destroyPlayerTwoCol();
                $('#da-two-col-lm-val').val("");

            } else {
                $('.digital-lemonade-wrap .digital-lemonade-wrap-inner > div').removeAttr('id');
                $('html,body').animate({
                        scrollTop: $("#" + da_section_id).offset().top - 110
                    },
                    200);
                $('#' + da_section_id).children('div').attr('id', 'player');
                //$('#'+lemonade_id).slideDown();                
                setTimeout(function () {
                    LemonadePlayerTwoCol(targetId, da_section_id);
                }, 100);
            }

            querySelector.addEventListener("click", function () {
            });
            return;
        })
    }
});


//Two Column Accordion Content
jQuery(document).ready(function () {

    function destroyAccordionPlayer() {
        const playerNode = document.getElementById("player");
        while (playerNode.firstChild) {
            playerNode.removeChild(playerNode.lastChild);
        }
    }

    function LemonadePlayerInit(targetId) {
        destroyAccordionPlayer();
        Lemonade.DemoPlayer.play({
            demo: targetId,
            container: $("#player"),
            disableAutoScroll: false,
            finishButtonText: "Close",
            horizontalPadding: 25,
            onFinish: (playerInstance) => {
                setTimeout(function () {
                    $('html,body').animate({
                            scrollTop: $(".two-col-accordion-content").offset().top - 110
                        },
                        'slow');
                }, 500);
                destroyAccordionPlayer();
                playerInstance.restart();
            },
            onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                // every time the scene changes, this event is called
            },
        });
    }

    //Two Column Accordion Lemonade
    if ($('.two-col-accordion-content').length > 0) {
        $('.two-col-accordion-content .two-col-right-title .two-col-acc-lm-btn, .two-col-accordion-content .two-col-right-title .two-col-acc-text').click(function (event) {
            event.preventDefault();
            var lemonade_id = $(this).attr('data-attr-id');
            var inputval = $('#two-col-acc-lm-val').val();
            var targetId = $(this).attr('data-id');
            $('#two-col-acc-lm-val').val(lemonade_id);
            let querySelector = document.querySelector(".two-col-accordion-content .two-col-right-title .two-col-acc-lm-btn, .two-col-accordion-content .two-col-right-title .two-col-acc-text");
            querySelector.removeEventListener("click", function () {
            });
            if (lemonade_id === inputval) {
                $('#two-col-acc-lm-val').val("");
                destroyAccordionPlayer();
            } else if (lemonade_id != inputval) {
                $('.digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
                $('html,body').animate({
                        scrollTop: $(".digital-lemonade-wrap").offset().top - 110
                    },
                    200);
                $('#' + lemonade_id).slideDown();
                setTimeout(function () {
                    LemonadePlayerInit(targetId);
                }, 100);
            }
            querySelector.addEventListener("click", function () {
            });
            return;
        })
    }
});


//Two Column Content Image Block Layout 1
jQuery(document).ready(function () {
    if ($('.two-col-content-image-block').length > 0) {

        function destroyPlayerTwoColLyout1() {
            const playerNode = document.getElementById("player");
            while (playerNode.firstChild) {
                playerNode.removeChild(playerNode.lastChild);
            }
        }

        function LemonadePlayerInitSingle(targetId) {

            destroyPlayerTwoColLyout1();
            Lemonade.DemoPlayer.play({
                demo: targetId,
                container: $("#player"),
                disableAutoScroll: false,
                finishButtonText: "Close",
                horizontalPadding: 25,
                onFinish: (playerInstance) => {
                    setTimeout(function () {
                        $('html,body').animate({
                                // scrollTop: $(".digital-academy-content").offset().top},
                                scrollTop: $(".two-col-content-image-block").offset().top - 110
                            },
                            'slow');
                    }, 500);
                    destroyPlayerTwoColLyout1();
                    playerInstance.restart();
                },
                onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                    // every time the scene changes, this event is called
                },
            });

        }

        $('.two-col-content-image-block .two-col-img-left-content-wrap .two-col-acc-lm-btn').click(function () {
            var targetId = $(this).attr('data-id');
            var lemonade_id = $(this).attr('data-attr-id');

            //$('.two-col-content-image-block .digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
            $('html,body').animate({
                    scrollTop: $(".two-col-content-image-block .digital-lemonade-wrap").offset().top - 110
                },
                200);
            //$('#'+lemonade_id).slideDown();                
            setTimeout(function () {
                LemonadePlayerInitSingle(targetId);
            }, 100);

        });
    }
});


//Two Column Content Image Block Layout 2
jQuery(document).ready(function () {

    function destroyPlayerTwoColLyout2() {
        const playerNode = document.getElementById("player");
        while (playerNode.firstChild) {
            playerNode.removeChild(playerNode.lastChild);
        }
    }

    function LemonadePlayerInit(targetId) {
        destroyPlayerTwoColLyout2();
        Lemonade.DemoPlayer.play({
            demo: targetId,
            container: $("#player"),
            disableAutoScroll: false,
            finishButtonText: "Close",
            horizontalPadding: 25,
            onFinish: (playerInstance) => {
                setTimeout(function () {
                    $('html,body').animate({
                            scrollTop: $(".two-col-content-image-block").offset().top - 110
                        },
                        'slow');
                }, 500);
                destroyPlayerTwoColLyout2();
                playerInstance.restart();
            },
            onStepChange: function (previousStep, currentStep, currentHotspot, totalSteps) {
                // every time the scene changes, this event is called
            },
        });
    }

    //Two Column Content Image Block Layout 2 Lemonade
    if ($('.two-col-content-image-block').length > 0) {
        $('.two-col-content-image-block .two-col-img-left-content-wrap .two-col-acc-lm-btn').click(function (event) {
            event.preventDefault();
            var lemonade_id = $(this).attr('data-attr-id');
            var inputval = $('#two-col-acc-lm-val').val();
            var targetId = $(this).attr('data-id');
            $('#two-col-acc-lm-val').val(lemonade_id);
            let querySelector = document.querySelector(".two-col-content-image-block .two-col-img-left-content-wrap .two-col-acc-lm-btn");
            querySelector.removeEventListener("click", function () {
            });
            if (lemonade_id === inputval) {
                $('#two-col-acc-lm-val').val("");
                destroyPlayerTwoColLyout2();
            } else if (lemonade_id != inputval) {
                $('.digital-lemonade-wrap-inner .digital-lemonade-code > div').removeAttr('id');
                $('html,body').animate({
                        scrollTop: $(".digital-lemonade-wrap").offset().top - 110
                    },
                    200);
                $('#' + lemonade_id).slideDown();
                setTimeout(function () {
                    LemonadePlayerInit(targetId);
                }, 100);
            }
            querySelector.addEventListener("click", function () {
            });
            return;
        })
    }
});


//Progress btn (Sticky CTA) Styles
$.fn.lettering = function (name) {
    var t = this.text(),
        tl = t.length,
        r = '';
    for (var i = 0; i < tl; i++) {

        if (t[i] == '.') {
            r += '<span class="' + name + '-' + i + ' dots">' + t[i] + '</span>';
        } else {
            r += '<span class="' + name + '-' + i + '">' + t[i] + '</span>';
        }

    }
    this.html(r);
};


$('.section-download_button .circle .text').lettering('char');


setScrollPercentforButton();
$(document).on('scroll', function () {
    setScrollPercentforButton();
});

function setScrollPercentforButton() {
    let scrollAmount = $(window).scrollTop();
    let documentHeight = $(document).height();
    let windowHeight = $(window).height();
    let scrollPercent = (scrollAmount / (documentHeight - windowHeight)) * 100;

    $(".section-download_button .circle-inner .wave").css("transform", "translateY(" + scrollPercent + "%)");
    if (scrollPercent === 100) {
        $(".section-download_button .circle-inner .wave").addClass("-end");
    } else {
        $(".section-download_button .circle-inner .wave").removeClass("-end");
    }
}


//Unique Code Block
jQuery(document).ready(function () {

    if($('.section-unique-code-block').length > 0) {
        $(".section-unique-code-block .get-code-btn").click(function () {
            $(".section-unique-code-block .unique-code-wrap").slideDown("slow");
        });


        // Check if the cookie exists
        var uniqueCodeCookie = getCookie('uniquecodecookie');
        if (uniqueCodeCookie) {
            // Hide the button
            $('.section-unique-code-block .get-code-btn').parent().parent().hide();
            // Display the message
            $('.section-unique-code-block #code-cookie-msg').show();
            $('.section-unique-code-block .no-code-msg').hide();
            $(".section-unique-code-block .unique-code-wrap").show();
            $(".section-unique-code-block .unique-code-wrap .short-desc").hide();
            $(".section-unique-code-block .unique-code-wrap .use-code-btn-wrap").hide();
            $(".section-unique-code-block .unique-code-wrap .copy-btn").hide();
        }

        // Function to retrieve the value of a specific cookie
        function getCookie(name) {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.indexOf(name + '=') === 0) {
                    return cookie.substring(name.length + 1);
                }
            }
            return '';
        }


        // Function to fetch the unique code and set a cookie
        async function fetchUniqueCodeAndSetCookie() {
            try {
                // Check if the cookie exists
                var uniqueCodeCookie = getCookie('uniquecodecookie');
                if (!uniqueCodeCookie) {
                    // Make an AJAX request to the server
                    const response = await $.ajax({
                        url: '/wp-content/themes/plainscapitalbank/core/functions/fetch-unique-code.php',
                        type: 'POST',
                    });

                    // Handle the response from the server
                    console.log(response);

                    // Update the input value with the fetched value
                    $('.section-unique-code-block #unique-code-val').val(response);

                    // Set a cookie with the fetched value
                    document.cookie = 'uniquecodecookie=' + response;

                    // Disable the button
                    $('.section-unique-code-block .get-code-btn').parent().parent().hide();

                    // Call the handleUnicodePluginMail function after fetching the unique code and setting the cookie
                    await handleUnicodePluginMail();
                }
            } catch (error) {
                console.error(error);
            }
        }

        // Function to handle the AJAX request for the unicode-plugin-mail.php
        async function handleUnicodePluginMail() {
            try {
                // Perform AJAX request to the server-side script
                const response = await $.ajax({
                    url: '/wp-content/themes/plainscapitalbank/core/functions/unicode-plugin-mail.php',
                    type: 'POST',
                });

                console.log(response); // Show the response message
            } catch (error) {
                console.error(error); // Log any errors to the console
            }
        }

        // Click event handler for fetching unique code and setting the cookie
        $('.section-unique-code-block .get-code-btn').click(async function () {
            await fetchUniqueCodeAndSetCookie();
        });
    }


});


//Market Insights page Form Multiselect 
jQuery(document).ready(function () {
    $('.contact-callout-block-wrapper .contact-form-wrapper #sign-up-interested').multiselect({
        selectAll: true,
        texts: {
            placeholder: 'WHAT ARE YOU INTERESTED IN?',
        }
    });



    // Search fields placeholder changing
    var searchFields = document.getElementsByClassName("addsearch");

    // Loop through each search field
    for (var i = 0; i < searchFields.length; i++) {
        // Modify the placeholder attribute
        searchFields[i].placeholder = "What can we help you find?";
    }    
});


//Video Block video popup
jQuery(document).ready(function ($) {
    $('[data-fancybox]').fancybox({
        type: 'iframe',
        iframe: {
            preload: false // Prevent auto-loading the video
        }
    });
});

$(function () {

    // Sticky menu script for Hero Header - Plain Mini Nav
    if ($(window).width() > 767) {
        function stickyMiniNav() {
            if ($(window).scrollTop() > 465) {
                $('#mini-nav-sticky').addClass('fixed');
            } else {
                $('#mini-nav-sticky').removeClass('fixed');
            }
        }

        stickyMiniNav();
        $(window).scroll(function () {
            stickyMiniNav();
        });
    } else if ($(window).width() > 480) {
        function stickyMiniNav() {
            if ($(window).scrollTop() > 400) {
                $('#mini-nav-sticky').addClass('fixed');
            } else {
                $('#mini-nav-sticky').removeClass('fixed');
            }
        }

        stickyMiniNav();
        $(window).scroll(function () {
            stickyMiniNav();
        });
    } else if ($(window).width() > 200) {
        function stickyMiniNav() {
            if ($(window).scrollTop() > 350) {
                $('#mini-nav-sticky').addClass('fixed');
            } else {
                $('#mini-nav-sticky').removeClass('fixed');
            }
        }

        stickyMiniNav();
        $(window).scroll(function () {
            stickyMiniNav();
        });
    }


    //script for Hero Header - Plain Mini Nav
    function getSelectedValue(id) {
        return $("#" + id).find(".mini-nav-dropdown dt a span.value").html();
    }

    $(".nav-dropdown dt a").click(function (e) {
        $(".nav-dropdown dd ul").toggle();
        e.preventDefault();
    });

    $(".nav-dropdown dd ul li a").click(function () {
        var text = $(this).html();
        $(".nav-dropdown dt a span").html(text);
        $(".nav-dropdown dd ul").hide();

    });

    $(document).bind('click', function (e) {
        var $clicked = $(e.target);
        if (!$clicked.parents().hasClass("nav-dropdown"))
            $(".nav-dropdown dd ul").hide();
    });

    if ($('#mini-nav-sticky').length) {
        $(function () {
            $('#mini-nav-sticky  a[href*="#"]:not([href="#"])').click(function () {
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var mini_target = $(this.hash);
                    mini_target = mini_target.length ? mini_target : $('[name=' + this.hash.slice(1) + ']');
                    if (mini_target.length) {
                        $('html, body').animate({
                            scrollTop: mini_target.offset().top - 150  // Add a top margin of 80px
                        }, 1000);
                        return false;
                    }
                }
            });
        });
    }
});


$(document).ready(function() {
    if($('.hover-zip-unzip-image-block').length > 0) {

         // Apply 'active' class to the first item on page load
        $('.hover-zip-unzip-img:first-child').addClass('active');
        $('.hover-zip-unzip-cnt:first-child').addClass('active');

        // Function to handle hover and adjust image positions
        function handleHover(index) {
            // Remove active class from all items
            $('.hover-zip-unzip-img, .hover-zip-unzip-cnt').removeClass('active');

            // Add active class to the specific items
            var activeImg = $('.hover-zip-unzip-img[data-index="' + index + '"]');
            var activeCnt = $('.hover-zip-unzip-cnt[data-index="' + index + '"]');
            activeImg.addClass('active');
            activeCnt.addClass('active');

            // Check if the screen width is 1024px or less
            if (window.innerWidth >= 1024) {
                // Get the offset position of the active content section
                var contentOffset = activeCnt.position().top;

                // Adjust all images based on the active content's position
                $('.hover-zip-unzip-img').each(function () {
                    var imgIndex = $(this).data('index');
                    if (imgIndex == index) {
                        // Move the active image 20px above the active content position
                        $(this).css({
                            'transform': 'translateY(' + (contentOffset) + 'px)', // Adjust -20px as needed
                            'transition': 'transform 0.3s ease'
                        });
                    } else {
                        // Reset other images to their default position
                        $(this).css({
                            'transform': 'translateY(0)',
                            'transition': 'transform 0.3s ease'
                        });
                    }
                });
            } else {
                // Reset transforms when the screen width is above 1024px
                $('.hover-zip-unzip-img').css({
                    'transform': 'translateY(0)',
                    'transition': 'transform 0.3s ease'
                });
            }
        }

        // Hover event for '.hover-zip-unzip-cnt'
        $('.hover-zip-unzip-cnt').hover(function() {
            var index = $(this).data('index');
            handleHover(index);
        });

        // Hover event for '.hover-zip-unzip-img'
        $('.hover-zip-unzip-img').hover(function() {
            var index = $(this).data('index');
            handleHover(index);
        });

        

    }
});

//Header nav scroll
$(document).ready(function() {
    var $fdicLogoNav = $('.fdic-logo-nav'); 
    var $stickyNoticeAbove = $('.sticky-ntce-abv'); 
    var $stickyNoticeBelow = $('.sticky-ntce-blw'); 
    var triggerHeight = 150;

    // Initially show FDIC logo and sticky notice below the menu, hide sticky notice above
    $fdicLogoNav.show();
    $stickyNoticeAbove.hide();
    $stickyNoticeBelow.show();

    // Handle scroll event
    $(window).on('scroll', function() {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > triggerHeight) {
            // Scroll down past triggerHeight hide FDIC logo and sticky notice below, show sticky notice above
            $fdicLogoNav.hide();
            $stickyNoticeBelow.hide();
            $stickyNoticeAbove.show();

        } else {
            // Scroll back up to the top: show FDIC logo and sticky notice below, hide sticky notice above
            $fdicLogoNav.show();
            $stickyNoticeBelow.show();
            $stickyNoticeAbove.hide();
        }
    });
});


//Homepage mobile background image chnage script
$(document).ready(function() {
    function setBackground() {
        $('.home-hero-section .bg-img').each(function() {
            var mobileBg = $(this).data('mobile-bg');

            if ($(window).width() <= 768) {
                $(this).css('background-image', 'url(' + mobileBg + ')');
            } 
            // No need to set the desktop background explicitly, as it's already set in the inline style
        });
    }

    // Set background on page load
    setBackground();

    // Optional: Change background on window resize
    $(window).on('resize', function() {
        setBackground();
    });
});

//Page Builder Hero section mobile background image chnage script
$(document).ready(function() {
    function setBackground() {
        $('.hero-builder .bg-img').each(function() {
            var mobileBg = $(this).data('mobile-bg');

            if ($(window).width() <= 768) {
                $(this).css('background-image', 'url(' + mobileBg + ')');
            } 
            // No need to set the desktop background explicitly, as it's already set in the inline style
        });
    }

    // Set background on page load
    setBackground();

    // Optional: Change background on window resize
    $(window).on('resize', function() {
        setBackground();
    });
});


// WEBPACK FOOTER //
// ./src/js/entry.es6